// Shared failure reporting for the media uploaders.
//
// Every upload path used to swallow a rejection to console.error: the progress bar
// still ran to 100%, the library reloaded, and the file simply was not there. To an
// author that reads as "it won't let me upload" with nothing to go on. These render
// the server's message next to the progress bar instead.
//
// Used by the Stimulus media picker, the TinyMCE MediaLibraryPlugin and the
// standalone MediaLibraryPicker, which all share the same progress markup.

const CONTAINER_ATTR = "data-upload-errors";

// Reads the error message out of a failed upload response, falling back to
// something honest when the body is not the JSON we expect.
export async function uploadErrorMessage(response) {
  try {
    const body = await response.json();
    if (body && body.error) return body.error;
  } catch {
    // Non-JSON body (a proxy timeout or an HTML error page) — fall through.
  }

  return `Upload failed (${response.status})`;
}

// Renders one red line per failed file below the progress bar. Replaces whatever
// was there before, so a later run does not stack old failures on new ones.
export function renderUploadFailures(progressEl, failures) {
  if (!progressEl) return;

  const existing = progressEl.querySelector(`[${CONTAINER_ATTR}]`);
  if (existing) existing.remove();
  if (!failures || failures.length === 0) return;

  const list = document.createElement("div");
  list.setAttribute(CONTAINER_ATTR, "");
  list.className = "mt-2 space-y-1";

  failures.forEach(({name, message}) => {
    const row = document.createElement("p");
    row.className = "text-xs text-red-600";
    // textContent, not innerHTML — the filename comes from the author's disk.
    row.textContent = `${name}: ${message}`;
    list.appendChild(row);
  });

  progressEl.appendChild(list);
  // Failures have to outlive the progress bar, which each caller hides on finish.
  progressEl.classList.remove("hidden");
}

export function clearUploadFailures(progressEl) {
  renderUploadFailures(progressEl, []);
}
